const baseURL = `${process.env.REACT_APP_BASE_URL}/api`
const baseScanningURL = `${process.env.REACT_APP_SCANNING_MONITORING_API_URL}/api`


const headers = {
    'Access-Control-Allow-Origin': '*',
    'Access-Control-Allow-Methods': 'GET,PUT,POST,DELETE,PATCH,OPTIONS',
}

// API to get plan list
const getPlanListApi = async (
    token: string, // access token
    planType: number // plan type
): Promise<any> => {

    const url = `${baseURL}/package-list`;

    const data = new FormData();
    data.append("product_type", planType.toString());


    try {
        const response = await fetch(url, {
            method: 'POST',
            headers: {
                ...headers,
                "Authorization": "Bearer " + token
            },
            body: data,
        });
        return await response.json();
    } catch (error) {
        return Promise.reject;
    }
}


// API to get current package
const getCurrentPackageApi = async (
    token: string, // access token 
    packageID: number, // package Id
    websiteID: number, // website ID
): Promise<any> => {

    const url = `${baseURL}/package-detail`;

    const data = new FormData();
    data.append("id", packageID.toString());
    data.append("website_id", websiteID.toString());

    try {
        const response = await fetch(url, {
            method: 'POST',
            headers: {
                ...headers,
                "Authorization": "Bearer " + token
            },
            body: data,
        });
        return await response.json();
    } catch (error) {
        return Promise.reject;
    }
}

// API to enable or disable add-on
const packageEnableDisableApi = async (
    accessToken: string, // access token
    website_id: number, // website ID
    package_id: number, // add on package Id
    package_status: number // package status
): Promise<any> => {

    const url = `${baseURL}/partner-adon-status-change`;

    const formData = new FormData();

    formData.append("website_id", website_id.toString());
    formData.append("adon_id", package_id.toString());
    formData.append("status", package_status.toString());

    try {
        const response = await fetch(url, {
            method: 'POST',
            headers: {
                ...headers,
                "Authorization": "Bearer " + accessToken
            },
            body: formData
        });

        return await response.json();
    } catch (error) {
        return Promise.reject;
    }
}

// API to get current package
const getScanningMonitoringPackageApi = async (
    token: string, // access token 
): Promise<any> => {

    const url = `${baseScanningURL}/package-list-dashboard`;

    try {
        const response = await fetch(url, {
            method: 'POST',
            headers: {
                ...headers,
                "Authorization": "Bearer " + token
            }
        });
        return await response.json();
    } catch (error) {
        return Promise.reject;
    }
}

// API to get Domain Register Login url
const getScanningMonitoringDomainRegisterLoginApi = async (
    token: string, // access token,
    companyName: string, // set state
    email:string,
    name:string,
    domain:string,
    package_id:string,
    interval:string,
): Promise<any> => {

    const url = `${baseScanningURL}/domain-register-login`;

    const formData = new FormData();

    formData.append("company_name", companyName.toString());
    formData.append("email", email.toString());
    formData.append("name", name.toString());
    formData.append("url", domain.toString());
    formData.append("package_id", package_id.toString())
    formData.append("interval", interval.toString())

    try {
        const response = await fetch(url, {
            method: 'POST',
            headers: {
                ...headers,
                "Authorization": "Bearer " + token
            },
            body: formData
        });
        return await response.json();
    } catch (error) {
        return Promise.reject;
    }
}

// API to get Domain active Status
const getScanningMonitoringDomainActiveStatusApi = async (
    token: string, // access token,
    domain: string, // set state
): Promise<any> => {

    const url = `${baseURL}/check-add-on-domain-status`;

    const formData = new FormData();

    formData.append("slug", 'scanner_plan');
    formData.append("website", domain.toString());

    try {
        const response = await fetch(url, {
            method: 'POST',
            headers: {
                ...headers,
                "Authorization": "Bearer " + token
            },
            body: formData
        });
        return await response.json();
    } catch (error) {
        return Promise.reject;
    }
}

export { getPlanListApi, getCurrentPackageApi, packageEnableDisableApi, getScanningMonitoringPackageApi, getScanningMonitoringDomainRegisterLoginApi, getScanningMonitoringDomainActiveStatusApi }